export const MAX_ZOOM_SCALE = 5
export const MIN_ZOOM_SCALE = 1
export const SLIDER_ZOOM_STEP = 0.1
export const WHEEL_ZOOM_STEP = 0.5
export const DEFAULT_DRAG_POSITION = { x: 0, y: 0 }
